import {UntypedFormGroup} from '@angular/forms';
import {FieldConfigWrapper} from './field-config-wrapper';

export interface DynamicFieldComponent {
    fieldWrapper: FieldConfigWrapper<any>;
    formGroup: UntypedFormGroup;
    maxCollapsedWidth: number;
}

